export default "__VITE_ASSET__BQ$vZajK__"